import { useEffect, useState } from "react";
import { api } from "../api";

type Settings = { enabled: boolean | number; email: string; phone: string; maxCount: number };
export function SendTestSettings({eventId, saving, onReady}: {eventId:number; saving:boolean; onReady:(ready:boolean)=>void}) {
  const [settings, setSettings] = useState<Settings | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    onReady(false);
    api<Settings>(`/api/communications/send-tests?eventId=${eventId}`).then(value => {
      if (active) {setSettings(value); onReady(true);}
    }).catch(e => {if (active) setError(e.message);});
    return () => {active = false;};
  }, [eventId]);
  return <section className="panel settings-main settings-full send-test-settings">
    <div className="panel-heading compact"><div><h2>Test de Envíos</h2><p>Probá los mensajes antes de enviarlos a los destinatarios del evento.</p></div></div>
    {error && <p role="alert">{error}</p>}
    {!settings ? <p>{error ? "No se pudo cargar la configuración." : "Cargando configuración…"}</p> : <>
      <input type="hidden" name="sendTestSettings" value={JSON.stringify(settings)} />
      <fieldset disabled={saving} style={{border:0,padding:0,margin:0}}>
        <div className="send-test-controls">
          <input aria-label="Habilitar Test de Envíos" type="checkbox" role="switch" checked={Boolean(settings.enabled)} onChange={e => setSettings({...settings,enabled:e.target.checked})}/>
          {Boolean(settings.enabled) && <>
            <label className="field"><span>Email de prueba</span><input type="email" required value={settings.email} onChange={e => setSettings({...settings,email:e.target.value})} autoComplete="off"/></label>
            <label className="field"><span>WhatsApp de prueba</span><input type="tel" required value={settings.phone} placeholder="+549…" onChange={e => setSettings({...settings,phone:e.target.value})} autoComplete="off"/></label>
            <label className="field"><span>Cantidad por canal</span><input type="number" min={1} max={1000} required value={settings.maxCount} onChange={e => setSettings({...settings,maxCount:Number(e.target.value)})}/></label>
          </>}
        </div>
        {Boolean(settings.enabled) && <>
          <p className="field-help">Con cantidad 2 y 50 destinatarios se enviarán como máximo 2 emails y 2 WhatsApp a los destinos de prueba. Se conserva el contenido personalizado. Los push quedan suspendidos y las pruebas no marcan a los participantes como notificados.</p>
          <p className="field-help">Los procesos automáticos comparten ese límite hasta que vuelvas a guardar la configuración. Se conservan los adjuntos. Los códigos y enlaces para ingresar o recuperar contraseñas enviados como prueba no habilitan accesos reales.</p>
        </>}

      </fieldset>
    </>}
  </section>;
}
